import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import el from 'date-fns/locale/el';
import FormSelect from '../form-select';
import { useSaleFormContext } from './SaleFormContext';
registerLocale('el', el);

function TransportSection({
    transportInfoDisplay,
    isDeliverMandatory,
    isLoadingMandatory,
    dispatchDate,
    dispatchStartDate,
    onChangeDispatchDate,
    onChangeMovePurpose,
    initiallyCollapsedDeliveryMore,
    movePurposes,
}) {
    const { t, i18n } = useTranslation();
    const { isFieldRequired, isVisible } = useSaleFormContext();
    const { register, control, formState: { errors } } = useFormContext();

    return (
        <>
            {/* Sender / Recipient cards */}
            <div className="row g-2 mt-1" style={{ display: transportInfoDisplay }}>
                <div className="col-md-6">
                    <div className="transport_information_container card">
                        <div className="card-header">
                            <i className="fa fa-sign-out transport-card-icon"></i>
                            <span>{t("senderName")}</span>
                        </div>
                        <div className="card-body py-2 px-3">
                            <div className="row g-2">
                                <div className="col-md-6 form-group">
                                    <label className="control-label inputlabel">{t("senderName")}</label>
                                    <input
                                        name="senderName"
                                        maxLength={20}
                                        {...register('senderName', { maxLength: 20 })}
                                        className={`form-control ${errors.senderName ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">{errors.senderName?.message}</div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label inputlabel">{t("senderTaxPayerId")}</label>
                                    <input
                                        name="senderTaxPayerId"
                                        maxLength={200}
                                        {...register('senderTaxPayerId', { maxLength: 200 })}
                                        className={`form-control ${errors.senderTaxPayerId ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">{errors.senderTaxPayerId?.message}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="transport_information_container card">
                        <div className="card-header">
                            <i className="fa fa-sign-in transport-card-icon"></i>
                            <span>{t("recipientName")}</span>
                        </div>
                        <div className="card-body py-2 px-3">
                            <div className="row g-2">
                                <div className="col-md-6 form-group">
                                    <label className="control-label inputlabel">{t("recipientName")}</label>
                                    <input
                                        name="recipientName"
                                        maxLength={200}
                                        {...register('recipientName', { maxLength: 200 })}
                                        className={`form-control ${errors.recipientName ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">{errors.recipientName?.message}</div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label inputlabel">{t("recipientTaxPayerId")}</label>
                                    <input
                                        name="recipientTaxPayerId"
                                        maxLength={20}
                                        {...register('recipientTaxPayerId', { maxLength: 20 })}
                                        className={`form-control ${errors.recipientTaxPayerId ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">{errors.recipientTaxPayerId?.message}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Traffic data accordion */}
            <div className="accordion" id="deliveryMoreAccordion">
                <div className="accordion-item" style={{ padding: 0 }}>
                    <div
                        id="deliverySectionCollapseOne"
                        className={`accordion-collapse collapse${initiallyCollapsedDeliveryMore.show ? ' show' : ''}`}
                        aria-labelledby="headingDeliveryExtra"
                        data-bs-parent="#deliveryMoreAccordion"
                    >
                        <div className="accordion-body p-0">
                            <div
                                style={{ display: isVisible('transformDataCard') ? 'unset' : 'none' }}
                                className="card transformDataCard mt-2"
                            >
                                <div className="card-header">
                                    <i className="fa fa-truck transport-card-icon"></i>
                                    <span>{t("TrafficData")}</span>
                                </div>
                                <div className="card-body px-3 py-2">

                                    {/* Traffic fields row */}
                                    <div className="row g-2 align-items-end">
                                        <div className={`col-md-3 selectInputContainer form-group movePurposeContainer ${isDeliverMandatory ? 'required' : ''}`}>
                                            <label className="control-label inputlabel">{t('MovePurpose')}</label>
                                            <Controller
                                                render={({ field }) => (
                                                    <FormSelect
                                                        field={field}
                                                        isClearable
                                                        onChange={onChangeMovePurpose}
                                                        options={movePurposes}
                                                        error={errors.movePurpose}
                                                    />
                                                )}
                                                control={control}
                                                rules={{ required: isDeliverMandatory }}
                                                name="movePurpose"
                                            />
                                            <div className="invalid-feedback">{errors.movePurpose?.message}</div>
                                        </div>
                                        <div className={`col-md-3 form-group otherMovePurposeTitleContainer ${isFieldRequired('otherMovePurposeTitle') ? 'required' : ''}`}>
                                            <label className="control-label inputlabel">{t("OtherMovePurposeTitle")}</label>
                                            <input
                                                name="otherMovePurposeTitle"
                                                maxLength={150}
                                                {...register('otherMovePurposeTitle', { maxLength: 150, required: isFieldRequired("otherMovePurposeTitle") })}
                                                className={`form-control ${errors.otherMovePurposeTitle ? 'is-invalid' : ''}`}
                                                disabled={!isFieldRequired("otherMovePurposeTitle")}
                                            />
                                            <div className="invalid-feedback">{errors.otherMovePurposeTitle?.message}</div>
                                        </div>
                                        <div className="col-md-3 form-group">
                                            <label className="control-label inputlabel">{t('dispatchDateTime')}</label>
                                            <Controller
                                                render={({ field }) => (
                                                    <DatePicker {...field}
                                                        selected={new Date(dispatchDate)}
                                                        minDate={new Date(dispatchStartDate)}
                                                        onChange={onChangeDispatchDate}
                                                        showTimeSelect
                                                        dateFormat="dd/MM/yyyy HH:mm"
                                                        timeFormat="HH:mm"
                                                        timeIntervals="1"
                                                        autoComplete="off"
                                                        locale={i18n.language === 'el-GR' || i18n.language === 'gr' ? 'el' : undefined}
                                                        className={`form-control ${errors.dispatchDate ? 'is-invalid' : ''}`}
                                                    />
                                                )}
                                                control={control}
                                                name="dispatchDate"
                                                defaultValue=""
                                            />
                                            <div className="invalid-feedback">{errors.dispatchDate?.message}</div>
                                        </div>
                                        <div className="col-md-3 form-group">
                                            <label className="control-label inputlabel">{t("vehicleNumber")}</label>
                                            <input
                                                name="vehicleNumber"
                                                maxLength={20}
                                                {...register('vehicleNumber', { maxLength: 20 })}
                                                className={`form-control ${errors.vehicleNumber ? 'is-invalid' : ''}`}
                                            />
                                            <div className="invalid-feedback">{errors.vehicleNumber?.message}</div>
                                        </div>
                                    </div>

                                    {/* Loading address */}
                                    <div className="transport-address-section">
                                        <div className="transport-address-label">
                                            <i className="fa fa-dot-circle-o"></i>
                                            {t("loadingAddressHeader")}
                                        </div>
                                        <div className="row g-2 align-items-end">
                                            <div className={`col-md-4 form-group loadingAddressStreetContainer ${isLoadingMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("Street")}</label>
                                                <input
                                                    name="loadingAddressStreet"
                                                    maxLength={100}
                                                    autoComplete="new-password"
                                                    {...register('loadingAddressStreet', { maxLength: 100, required: isLoadingMandatory })}
                                                    className={`form-control ${errors.loadingAddressStreet ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.loadingAddressStreet?.message}</div>
                                            </div>
                                            <div className={`col-md-2 form-group loadingAddressNumberContainer ${isLoadingMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("Number")}</label>
                                                <input
                                                    name="loadingAddressNumber"
                                                    maxLength={20}
                                                    autoComplete="new-password"
                                                    {...register('loadingAddressNumber', { maxLength: 20, required: isLoadingMandatory })}
                                                    className={`form-control ${errors.loadingAddressNumber ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.loadingAddressNumber?.message}</div>
                                            </div>
                                            <div className={`col-md-4 form-group loadingAddressCityContainer ${isLoadingMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("City")}</label>
                                                <input
                                                    name="loadingAddressCity"
                                                    maxLength={100}
                                                    autoComplete="new-password"
                                                    {...register('loadingAddressCity', { maxLength: 100, required: isLoadingMandatory })}
                                                    className={`form-control ${errors.loadingAddressCity ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.loadingAddressCity?.message}</div>
                                            </div>
                                            <div className={`col-md-2 form-group loadingAddressPostalCodeContainer ${isLoadingMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("PostalCode")}</label>
                                                <input
                                                    name="loadingAddressPostalCode"
                                                    maxLength={20}
                                                    autoComplete="new-password"
                                                    {...register('loadingAddressPostalCode', { maxLength: 20, required: isLoadingMandatory })}
                                                    className={`form-control ${errors.loadingAddressPostalCode ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.loadingAddressPostalCode?.message}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Delivery address */}
                                    <div className="transport-address-section">
                                        <div className="transport-address-label">
                                            <i className="fa fa-map-marker"></i>
                                            {t("deliveryAddressHeader")}
                                        </div>
                                        <div className="row g-2 align-items-end">
                                            <div className={`col-md-4 form-group deliveryAddressStreetContainer ${isDeliverMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("Street")}</label>
                                                <input
                                                    name="deliveryAddressStreet"
                                                    maxLength={100}
                                                    autoComplete="new-password"
                                                    {...register('deliveryAddressStreet', { maxLength: 100, required: isDeliverMandatory })}
                                                    className={`form-control ${errors.deliveryAddressStreet ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.deliveryAddressStreet?.message}</div>
                                            </div>
                                            <div className={`col-md-2 form-group deliveryAddressNumberContainer ${isDeliverMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("Number")}</label>
                                                <input
                                                    name="deliveryAddressNumber"
                                                    maxLength={20}
                                                    autoComplete="new-password"
                                                    {...register('deliveryAddressNumber', { maxLength: 20, required: isDeliverMandatory })}
                                                    className={`form-control ${errors.deliveryAddressNumber ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.deliveryAddressNumber?.message}</div>
                                            </div>
                                            <div className={`col-md-4 form-group deliveryAddressCityContainer ${isDeliverMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("City")}</label>
                                                <input
                                                    name="deliveryAddressCity"
                                                    maxLength={100}
                                                    autoComplete="new-password"
                                                    {...register('deliveryAddressCity', { maxLength: 100, required: isDeliverMandatory })}
                                                    className={`form-control ${errors.deliveryAddressCity ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.deliveryAddressCity?.message}</div>
                                            </div>
                                            <div className={`col-md-2 form-group deliveryAddressPostalCodeContainer ${isDeliverMandatory ? 'required' : ''}`}>
                                                <label className="control-label inputlabel">{t("PostalCode")}</label>
                                                <input
                                                    name="deliveryAddressPostalCode"
                                                    maxLength={20}
                                                    autoComplete="new-password"
                                                    {...register('deliveryAddressPostalCode', { maxLength: 20, required: isDeliverMandatory })}
                                                    className={`form-control ${errors.deliveryAddressPostalCode ? 'is-invalid' : ''}`}
                                                />
                                                <div className="invalid-feedback">{errors.deliveryAddressPostalCode?.message}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TransportSection;
